export default {
    dCropsHeaders() {
        return [
            {
                value: "grouping.name",
                filterable: true,
                text: "Card"
            },
            {
                value: "edition",
                filterable: false,
                text: "Edition"
            },
            {
                value: "rarity",
                filterable: false,
                text: "Rarity"
            }
        ]
    }
}